import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GenerativeCard } from "@/components/generative-ui/shared/GenerativeCard";
import type {
  PersonaBuilderCard,
  CardActionHandler,
} from "@/components/generative-ui/envelope/types";

export interface Props {
  card: PersonaBuilderCard;
  onAction?: CardActionHandler;
}

export function PersonaBuilderView({ card, onAction }: Props) {
  const canActivate = !!card.persona_id;
  return (
    <GenerativeCard.Root variant="default">
      <GenerativeCard.Header>
        <span className="text-xs uppercase tracking-wide text-pink-600">Persona SDR</span>
        <span className="text-xs text-muted-foreground">· {card.name}</span>
      </GenerativeCard.Header>
      <GenerativeCard.Body>
        <Tabs defaultValue="prompt" className="w-full">
          <TabsList className="grid grid-cols-3">
            <TabsTrigger value="prompt">Prompt</TabsTrigger>
            <TabsTrigger value="rag">RAG Docs</TabsTrigger>
            <TabsTrigger value="sample">Amostra</TabsTrigger>
          </TabsList>
          <TabsContent value="prompt" className="text-sm whitespace-pre-wrap">
            {card.system_prompt}
          </TabsContent>
          <TabsContent value="rag">
            <ul className="text-sm space-y-1">
              {card.rag_documents.map((d) => (
                <li key={d.doc_id}>
                  <span className="font-medium">{d.title}</span>
                  <span className="ml-2 text-xs text-muted-foreground">({d.source})</span>
                </li>
              ))}
            </ul>
          </TabsContent>
          <TabsContent value="sample" className="text-sm text-muted-foreground">
            {card.role_description}
          </TabsContent>
        </Tabs>
      </GenerativeCard.Body>
      <GenerativeCard.Actions>
        <Button
          disabled={!canActivate}
          onClick={() =>
            onAction?.({
              intent: "activate_persona",
              payload: { persona_id: card.persona_id ?? "" },
            })
          }
        >
          Ativar persona
        </Button>
      </GenerativeCard.Actions>
    </GenerativeCard.Root>
  );
}
